import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: 24px;

    background: #ffffff;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.08);

    border-radius: 12px;

    outline: 1px solid #e5e7eb;
    outline-offset: -1px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`;

export const Message = styled.div`
    align-self: stretch;

    color: #6a7282;

    font-size: 14px;
    font-family: Inter, sans-serif;
    font-weight: 400;
    line-height: 20px;

    word-wrap: break-word;
`;

export const SearchForm = styled.form`
    width: 100%;
    padding-top: 16px;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    gap: 12px;
`;

export const SearchInput = styled.input`
    flex: 1 1 0;

    width: 100%;
    max-width: 448px;
    height: 38px;

    box-sizing: border-box;

    padding: 8px 14px;

    border: 1px solid #d6d6d6;
    border-radius: 8px;

    outline: none;

    color: #000000;

    font-size: 14px;
    font-family: Inter, sans-serif;
    font-weight: 400;
    line-height: 20px;

    &::placeholder {
        color: #000000;
        opacity: 1;
    }

    &:focus {
        border-color: #7951eb;
    }
`;

export const SearchButton = styled.button`
    padding: 12px 16px;

    background: #7951eb;

    border: none;
    border-radius: 4px;

    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    gap: 6px;

    color: #ffffff;

    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    line-height: 20px;

    text-align: center;
    text-transform: capitalize;
    letter-spacing: 1.25px;

    cursor: pointer;

    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background: #6840d8;
    }

    &:focus-visible {
        outline: 2px solid #7951eb;
        outline-offset: 2px;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;
